import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useGetAllPlaylistsQuery,
  useDeletePlaylistMutation,
} from "../../services/modules/playlist";
import {
  setSelectedPlaylist,
  resetPlaylistState,
} from "../../store/playlist";
import { ToastContainer, toast } from "react-toastify";

const PlaylistManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data, isLoading, refetch } = useGetAllPlaylistsQuery();
  const [deletePlaylist] = useDeletePlaylistMutation();

  const playlists = data?.data?.result || [];
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const openEditPage = (playlist) => {
    dispatch(setSelectedPlaylist(playlist));
    navigate(`/admin/playlist/${playlist.id}`);
  };

  const handleCreateNew = () => {
    dispatch(resetPlaylistState());
    navigate("/admin/playlist/new");
  };

  const handleDelete = async () => {
    console.log("Deleting playlist with ID:", deleteId);
    try {
        
        await deletePlaylist({ id: deleteId }).unwrap();
        toast.success("Playlist cancellata!");
      setDeleteId(null);
      setShowDeleteModal(false);
      await refetch();
    } catch (err) {
      toast.error("Errore durante l'eliminazione.",deleteId);
      console.error("Errore:", err);
    }
  };

  return (
    <div className="p-4">
      <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 9999 }} />
      <h2 className="text-xl font-bold mb-6">Playlist</h2>

      {isLoading ? (
        <p>Caricamento...</p>
      ) : playlists.length > 0 ? (
        <table className="min-w-full bg-white border text-base">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-2 py-1">ID</th>
              <th className="border px-2 py-1">Titolo</th>
              <th className="border px-2 py-1">Descrizione</th>
              <th className="border px-2 py-1">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {playlists.map((pl) => (
              <tr key={pl.id}>
                <td className="border px-2 py-1">{pl.id}</td>
                <td className="border px-2 py-1">{pl.name}</td>
                <td className="border px-2 py-1">{pl.description}</td>
                <td className="border px-2 py-1 t w-[200px] ">
                  <div className="flex gap-2 flex-wrap">
                    <button
                      onClick={() => openEditPage(pl)}
                      className="px-3 py-1 bg-gray-200 border border-gray-300 rounded"
                    >
                      Modifica
                    </button>
                    <button
                      onClick={() => {
                        setDeleteId(pl.id);
                        setShowDeleteModal(true);
                      }}
                      className="px-3 py-1 bg-gray-200 border border-gray-300 rounded"
                    >
                      Elimina
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-500">Nessuna playlist trovata.</p>
      )}

      <div className="flex justify-end mt-6">
        <button
          onClick={handleCreateNew}
          className="bg-gray-800 text-white px-5 py-2 rounded"
        >
          Aggiungi Playlist
        </button>
      </div>

      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded p-6 shadow-md text-center space-y-4 w-96">
            <h3 className="text-lg font-semibold">Conferma Eliminazione</h3>
            <p>Sei sicuro che vuoi cancellare questa playlist?</p>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setDeleteId(null);
                }}
                className="px-4 py-2 rounded bg-gray-300"
              >
                Annulla
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 rounded bg-red-500 text-white"
              >
                Elimina
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlaylistManager;